import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'otb-execution',
    component: () => import('./views/otb-execution-index.vue'),
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
  },
];
export default routes;
